const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsDeveloperAssociate = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Building Real Applications on AWS — The Foundation
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          The AWS Certified Developer – Associate certification marked the beginning of my journey
          in building cloud-native applications and working hands-on with AWS services.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/AwsDeveloperBadge.png"
          alt="AWS Certified Developer Associate"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified Developer – Associate
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification focuses on practical development — building, deploying, and debugging
          real applications in the AWS environment.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          It established a strong foundation in how cloud systems are actually implemented,
          not just how they are designed.
        </p>
      </div>


      {/* DEVELOPMENT CAPABILITIES */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Development Capabilities Built Early On
        </h2>

        <div style={gridStyle}>
          {[
            "Building serverless applications using AWS Lambda and API Gateway",
            "Designing backend logic for cloud-native systems",
            "Working with S3 for storage and file-based workflows",
            "Implementing scalable data access using DynamoDB",
            "Connecting services using event-driven patterns",
            "Handling application deployment and versioning",
            "Debugging and troubleshooting cloud applications",
            "Integrating multiple AWS services into working solutions"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* WHAT THIS ENABLES */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          What This Foundation Enables
        </h2>

        <div style={gridStyle}>
          {[
            "Building complete backend systems on AWS",
            "Understanding how applications behave in cloud environments",
            "Designing systems with real implementation constraints in mind",
            "Avoiding purely theoretical architecture decisions",
            "Bridging the gap between development and architecture"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* PROGRESSION 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          From Developer to Architect
        </h2>

        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification laid the groundwork for everything that followed.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          Starting from hands-on development, I expanded into architecture, DevOps, data,
          and AI — building complete, production-ready systems on AWS.
        </p>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Strong systems are built by people who understand both design and implementation.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          My approach is grounded in real development experience, ensuring that architectures
          are practical, efficient, and aligned with how systems actually work.
        </p>
      </div>


      {/* CTA */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Start Building on AWS the Right Way
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s build scalable and reliable cloud applications from the ground up.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your Application →
        </a>
      </div>

    </div>
  );
};

export default AwsDeveloperAssociate;